interface AppConfig {
  webchatUrl?: string;
  showInfiniMemory?: boolean;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

/**
 * 读取运行期配置。
 *
 * 生产环境：容器启动脚本根据环境变量生成 /config.js，
 * 写入 window.__APP_CONFIG__。当前支持 WEBCHAT_URL 和 SHOW_INFINI_MEMORY。
 *
 * 开发环境：public/config.js 默认为空，回退读取 .env.local 中的
 * VITE_WEBCHAT_URL / SHOW_INFINI_MEMORY，便于本地联调。
 */
export function getWebchatUrl(): string {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__?.webchatUrl) {
    return window.__APP_CONFIG__.webchatUrl;
  }
  const fromEnv = import.meta.env.VITE_WEBCHAT_URL as string | undefined;
  return fromEnv ?? '';
}

/**
 * 是否在前端展示 infini-memory 功能。
 *
 * 运行期配置优先于构建期配置；两者都未配置时默认隐藏。
 */
export function isInfiniMemoryVisible(): boolean {
  const runtimeValue =
    typeof window !== 'undefined' ? window.__APP_CONFIG__?.showInfiniMemory : undefined;
  if (typeof runtimeValue === 'boolean') {
    return runtimeValue;
  }
  return import.meta.env.SHOW_INFINI_MEMORY === 'true';
}
